<template>
  <div id="app">
    <v-container>
      <Header />
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-snackbar
        v-model="message.snackbar"
        :timeout="message.snackbarTimeout"
        bottom
      >
        {{ message.snackbarText }}
        <v-btn dark text @click="message.snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-dialog v-model="createCompanyDialog" scrollable max-width="500px">
        <v-card>
          <v-card-title>Create company</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-alert type="error" class="mt-5" v-if="showCompanyMessage" dense
              >Company already exists</v-alert
            >
            <v-form ref="createCompanyForm">
              <v-text-field
                v-model="companyForm.name"
                :rules="[rules.required]"
                label="Company"
                required
              ></v-text-field>
              <v-text-field
                v-model="companyForm.email"
                :rules="[rules.required, rules.email]"
                label="Email"
                required
              ></v-text-field>
              <v-file-input
                v-model="companyForm.logo"
                show-size
                label="File"
              ></v-file-input>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="createCompanyDialog = false"
              class="hp--btn"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              :loading="createCompanyLoader"
              @click="onCreateCompany()"
              class="hp--btn"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="updateCompanyDialog" scrollable max-width="500px">
        <v-card>
          <v-card-title>Update company</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="updateForm">
              <v-text-field
                v-model="companyUpdateForm.name"
                :rules="[rules.required]"
                label="Company"
                required
              ></v-text-field>
              <v-text-field
                v-model="companyUpdateForm.email"
                :rules="[rules.required, rules.email]"
                label="Email"
                required
              ></v-text-field>
              <v-file-input
                v-model="companyUpdateForm.logo"
                show-size
                label="File"
              ></v-file-input>
              <v-chip
                class="mr-2"
                close
                color="primary"
                align="right"
                v-if="fileUploadChip"
                @click:close="deleteCompanyAttachment(companyUpdateForm)"
              >
                <v-icon left>mdi-file-document</v-icon>
                {{ companyUpdateForm.filename }}
              </v-chip>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="updateCompanyDialog = false"
              class="hp--btn"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="onUpdateCompany()"
              :loading="updateCompanyLoader"
              class="hp--btn"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="createClientAccessDialog" scrollable max-width="500px">
        <v-card>
          <v-card-title>Create client access credentials</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-alert type="error" class="mt-5" v-if="showCompanyMessage" dense
              >Company already exists</v-alert
            >
            <v-form ref="createCompanyForm">
              <v-text-field
                v-model="companyForm.name"
                :rules="[rules.required]"
                label="Company"
                required
              ></v-text-field>
              <v-text-field
                v-model="companyForm.email"
                :rules="[rules.required, rules.email]"
                label="Email"
                required
              ></v-text-field>
              <v-file-input
                v-model="companyForm.logo"
                show-size
                label="File"
              ></v-file-input>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="createCompanyDialog = false"
              class="hp--btn"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              :loading="createClientAccessDialog"
              @click="onCreateClientAccess()"
              class="hp--btn"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div style="position: relative" v-if="switchEventPanel === 'companies'">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title class="grey--text">Companies</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  small
                  absolute
                  bottom
                  left
                  fab
                  v-on="on"
                  @click="
                    companyForm = [];
                    createCompanyDialog = !createCompanyDialog;
                  "
                  class="hp--btn"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>New company</span>
            </v-tooltip>
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text>
            <v-data-table
              :items="companys"
              :headers="companysHeaders"
              class="elevation-1"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              :search="search"
              :sort-by="['name']"
            >
              <template v-slot:item.action="{ item }">
                <v-chip
                  color="red lighten-4"
                  class="ml-0 mr-2 black--text"
                  label
                  small
                  >{{ item.active }}/{{ item.total }} active</v-chip
                >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      color="success"
                      @click="updateCompany(item)"
                      >edit</v-icon
                    >
                  </template>
                  <span>Update company</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="deleteCompany(item)" color="error"
                      >delete</v-icon
                    >
                  </template>
                  <span>Delete company</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      @click="viewClientAccess(item)"
                      color="secondary"
                      >group_add</v-icon
                    >
                  </template>
                  <span>Add client access</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="viewLocations(item)" color="info"
                      >mdi-home</v-icon
                    >
                  </template>
                  <span>View locations</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      class="mr-1"
                      @click="viewEvents(item)"
                      color="warning"
                      >mdi-bus</v-icon
                    >
                  </template>
                  <span>View events</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>

      <company-locations
        v-if="switchEventPanel === 'locations'"
        @switchEventPanel="childMessageReceived"
        :company="company"
      />

      <company-client-access
        v-if="switchEventPanel === 'clientaccess'"
        @switchEventPanel="childMessageReceived"
        :company="company"
      />

      <company-events
        v-if="switchEventPanel === 'events'"
        @switchEventPanel="childMessageReceived"
        :company="company"
      />
    </v-container>
  </div>
</template>

<script>
import { Storage } from "aws-amplify";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
import Header from "../components/Header.vue";
import { s3helper } from "../classes/s3helper";
import { Company } from "../classes/Company";
import CompanyLocations from "../components/CompanyLocations.vue";
import CompanyEvents from "../components/CompanyEvents.vue";
import CompanyClientAccess from "../components/CompanyClientAccess.vue";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    Header,
    CompanyLocations,
    CompanyEvents,
    CompanyClientAccess,
  },
  data() {
    return {
      createCompanyDialog: false,
      createClientAccessDialog: false,
      createCompanyLoader: false,
      updateCompanyDialog: false,
      updateCompanyLoader: false,
      switchCompanyEvent: true,
      showCompanyMessage: false,
      showCompanyUpdateMessage: false,
      loader: false,
      switchEventPanel: "companies",
      companys: [],
      clientaccess: [],
      companysHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
        },
        { text: "Created", value: "date" },
        { text: "Email", value: "email" },
        { value: "action", align: "right", sortable: false, width: 300 },
      ],
      company: [],
      companyForm: [],
      companyUpdateForm: [],
      fileUploadChip: false,
      rules: {
        required: (v) => !!v || "This field is required.",
        email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      },
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
      },
      itemsPerPage: -1,
      page: 0,
      nextToken: "",
      search: "",
    };
  },
  created() {
    const that = this;
    this.loader = true;

    const listEventCompanies = /* GraphQL */ `
      query ListEventCompanies(
        $filter: ModelEventCompanyFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listEventCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
          items {
            id
            name
            email
            logo
            createdAt
            isDeleted
            event(
              filter: {
                isDeleted: { eq: 0 }
              }
            ) {
              items {
                  id
                  name
                  status
                  createdAt
              }
            }
          }
          nextToken
        }
      }
    `;

    // while (this.nextToken !== null) {
    API.graphql(
      graphqlOperation(listEventCompanies, {
        filter: {
          isDeleted: {
            eq: 0,
          },
        },
        limit: 200, //this.itemsPerPage,
        // nextToken: this.nextToken
      })
    ).then((result) => {
      if(result.data.listEventCompanies){
        this.nextToken = result.data.listEventCompanies.nextToken;
        result.data.listEventCompanies.items.forEach(function (company) {
          if (company.isDeleted === 0) {
            var totalActive = company.event.items.filter(function (item) {
              return item.status === "Live";
            });
            that.companys.push({
              id: company.id,
              name: company.name,
              email: company.email,
              logo: company.logo,
              date: moment(company.createdAt).format("DD/MM/YYYY"),
              active: totalActive.length,
              total: company.event.items.length,
            });
          }
        });
      }
      
      this.loader = false;
    });
  },
  methods: {
    childMessageReceived(arg1) {
      this.switchEventPanel = arg1;
    },
    viewEvents(company) {
      this.company = company;
      this.switchCompanyEvent = !this.switchCompanyEvent;
      this.switchEventPanel = "events";
    },
    viewLocations(company) {
      this.company = company;
      this.switchCompanyEvent = !this.switchCompanyEvent;
      this.switchEventPanel = "locations";
    },
    viewClientAccess(company) {
      this.company = company;
      this.switchEventPanel = "clientaccess";
    },
    async onCreateCompany() {
      const isDuplicate = await new Company().isDuplicateCompany(
        this.companyForm.name.trim()
      );
      this.showCompanyMessage = false;
      if (isDuplicate) {
        this.showCompanyMessage = true;
        return;
      }

      this.createCompanyLoader = true;
      if (this.$refs.createCompanyForm.validate()) {
        if (this.companyForm.logo) {
          let file = this.companyForm.logo;
          this.companyForm.loading = true;
          const fileName = file.name;
          const s3Key = s3helper.generateS3Key(fileName);
          Storage.put("healthyevents/logo/" + s3Key, file, {
            level: "public",
            contentType: file.type,
          }).then((upload) => {
            API.graphql(
              graphqlOperation(mutations.createEventCompany, {
                input: {
                  name: this.companyForm.name.trim(),
                  email: this.companyForm.email,
                  createdAt: new Date().toISOString(),
                  logo: upload.key,
                  logoFileName: fileName,
                  isDeleted: 0,
                },
              })
            ).then((result) => {
              this.companys.push({
                id: result.data.createEventCompany.id,
                name: result.data.createEventCompany.name,
                email: result.data.createEventCompany.email,
                date: moment(result.data.createEventCompany.date).format(
                  "DD/MM/YYYY"
                ),
                active: 0,
                total: 0,
              });
              this.companys = _.orderBy(this.companys, "name", "asc");
              this.createCompanyDialog = false;
              this.showSuccessMessage(
                "New company " +
                  result.data.createEventCompany.name +
                  " created"
              );
              this.createCompanyLoader = false;
              this.createCompanyDialog = false;
              this.showSuccessMessage(
                "New company " +
                  result.data.createEventCompany.name +
                  " created"
              );
            });
          });
        } else {
          API.graphql(
            graphqlOperation(mutations.createEventCompany, {
              input: {
                name: this.companyForm.name,
                email: this.companyForm.email,
                createdAt: new Date().toISOString(),
                isDeleted: 0,
              },
            })
          ).then((result) => {
            this.companys.push({
              id: result.data.createEventCompany.id,
              name: result.data.createEventCompany.name,
              email: result.data.createEventCompany.email,
              date: moment(result.data.createEventCompany.date).format(
                "DD/MM/YYYY"
              ),
              active: 0,
              total: 0,
            });
            this.companys = _.orderBy(this.companys, "name", "asc");
            this.createCompanyDialog = false;
            this.showSuccessMessage(
              "New company " + result.data.createEventCompany.name + " created"
            );
          });
        }
      }
    },
    async onCreateClientAccess() {
      console.log("onCreateClientAccess");
    },
    async onUpdateCompany() {
      if (this.$refs.updateForm.validate()) {
        this.showCompanyUpdateMessage = false;

        let that = this;
        if (this.companyUpdateForm.id) {
          if (this.companyUpdateForm.logo) {
            this.updateCompanyLoader = true;
            let file = this.companyUpdateForm.logo;
            const fileName = file.name;
            const s3Key = s3helper.generateS3Key(fileName);
            Storage.put("healthyevents/logo/" + s3Key, file, {
              level: "public",
              contentType: file.type,
            }).then((upload) => {
              API.graphql(
                graphqlOperation(mutations.updateEventCompany, {
                  input: {
                    id: this.companyUpdateForm.id,
                    name: this.companyUpdateForm.name,
                    logo: upload.key,
                    logoFileName: fileName,
                    isDeleted: 0,
                  },
                })
              ).then((result) => {
                let companyUpdate = result.data.updateEventCompany;
                this.companys.forEach(function (company) {
                  if (company.id === that.companyUpdateForm.id) {
                    company.name = companyUpdate.name;
                    company.email = companyUpdate.email;
                  }
                });
                this.updateCompanyLoader = false;
                this.updateCompanyDialog = false;
                this.showSuccessMessage("Company updated");
              });
            });
          } else {
            API.graphql(
              graphqlOperation(mutations.updateEventCompany, {
                input: {
                  id: this.companyUpdateForm.id,
                  name: this.companyUpdateForm.name,
                  email: this.companyUpdateForm.email,
                  isDeleted: 0,
                },
              })
            ).then((result) => {
              let companyUpdate = result.data.updateEventCompany;
              this.companys.forEach(function (company) {
                if (company.id === that.companyUpdateForm.id) {
                  company.name = companyUpdate.name;
                  company.email = companyUpdate.email;
                }
              });
              this.updateCompanyDialog = false;
              this.showSuccessMessage("Company updated");
            });
          }
        }
      }
    },
    updateCompany: function (company) {
      API.graphql(
        graphqlOperation(queries.getEventCompany, {
          id: company.id,
        })
      )
        .then((result) => {
          let eventCompany = result.data.getEventCompany;
          this.companyUpdateForm.id = eventCompany.id;
          this.companyUpdateForm.name = eventCompany.name;
          this.companyUpdateForm.email = eventCompany.email;
          this.companyUpdateForm.filename = eventCompany.logoFileName;
          this.fileUploadChip = false;
          if (eventCompany.logoFileName !== null) {
            this.fileUploadChip = true;
          }
          this.updateCompanyDialog = !this.updateCompanyDialog;
        })
        .catch((err) => console.log(err));
    },
    deleteCompany(company) {
      const getEventCompany = /* GraphQL */ `
        query GetEventCompany($id: ID!) {
          getEventCompany(id: $id) {
            event {
              items {
                id
              }
            }
          }
        }
      `;

      var that = this;
      confirm("Are you sure you want to delete this company?") &&
        API.graphql(
          graphqlOperation(mutations.updateEventCompany, {
            input: {
              id: company.id,
              isDeleted: 1,
            },
          })
        )
          .then(async (res) => {
            // Delete all events associated with company
            const {
              data: {
                getEventCompany: {
                  event: { items: results },
                },
              },
            } = await API.graphql(
              graphqlOperation(getEventCompany, {
                id: company.id,
              })
            );
            results.map(async (event) => {
              await API.graphql(
                graphqlOperation(mutations.updateEvent, {
                  input: {
                    id: event.id,
                    isDeleted: 1,
                  },
                })
              );
            });

            that.companys.splice(that.companys.indexOf(company), 1);
            this.showSuccessMessage("Company deleted");
          })
          .catch((err) => console.log(err));
    },
    deleteCompanyAttachment({ id }) {
      if (confirm("Are you sure you want to delete company logo?")) {
        API.graphql(
          graphqlOperation(mutations.updateEventCompany, {
            input: {
              id: id,
              logo: null,
              logoFileName: null,
            },
          })
        ).then((result) => {
          this.fileUploadChip = false;
        });
      }
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    },
  },
};
</script>